import { createContext } from 'react'

const RmcContext = createContext()

export default RmcContext
